/* @flow */
import * as React from 'react';
import { make } from '../chunker';
import findByType from 'lib/findByType';
import ErrorReporter from 'app/components/ErrorReporter';

import type { DateSeparatorChunk, StreamItemsChunk, UnchunkedSequenceItems } from '../chunker';

type Props = {
  items: UnchunkedSequenceItems,
  children: React.Element[],
};

const GapChunk = (_props: { children: (chunk: StreamItemsChunk) => React.Element }) => null;
const DateChunk = (_props: { children: (chunk: DateSeparatorChunk) => React.Element }) => null;
const MessageChunk = (_props: { children: (chunk: StreamItemsChunk) => React.Element }) => null;
const PhoneCallChunk = (_props: { children: (chunk: StreamItemsChunk) => React.Element }) => null;
const VideoChatChunk = (_props: { children: (chunk: StreamItemsChunk) => React.Element }) => null;
const SystemMessageChunk = (_props: { children: (chunk: StreamItemsChunk) => React.Element }) =>
  null;

/* SequenceItemsChunker is a stream message rendered
 * that chunks stream message together, when the sender
 * is the same and the timestamps are within a a certain threhold
 *
 * The chunking let us only render a cleaner, and more compact message
 * cell if a particpant quickly sends multiple messages in a row.
 */
class SequenceItemsChunker extends React.Component<Props> {
  static GapChunk: React.Element;
  static DateChunk: React.Element;
  static MessageChunk: React.Element;
  static PhoneCallChunk: React.Element;
  static VideoChatChunk: React.Element;
  static SystemMessageChunk: React.Element;

  static CHUNK_TYPE_TO_CHILD_TYPE = {
    GapItem: GapChunk,
    DateSeparator: DateChunk,
    MessageItem: MessageChunk,
    PhoneCallItem: PhoneCallChunk,
    VideoChatMessageInviteItem: VideoChatChunk,
    SystemMessageItem: SystemMessageChunk,
  };

  shouldComponentUpdate(nextProps: Props) {
    const newPage = this.props.items.length !== nextProps.items.length;
    const newItem = this.props.items[0].key !== nextProps.items[0].key;

    return newPage || newItem;
  }

  render(): React.Element {
    if (this.props.items.length <= 0) {
      return null;
    }

    return make(this.props.items).map(chunk => {
      const childComponent = SequenceItemsChunker.CHUNK_TYPE_TO_CHILD_TYPE[chunk.type];
      const childElement = childComponent && findByType(this.props.children, childComponent);

      return childElement ? (
        childElement.props.children(chunk)
      ) : (
        <ErrorReporter
          key={chunk.key()}
          error={`could not find child for chunk of type: ${chunk.type}`}
        />
      );
    });
  }
}

SequenceItemsChunker.GapChunk = GapChunk;
SequenceItemsChunker.DateChunk = DateChunk;
SequenceItemsChunker.MessageChunk = MessageChunk;
SequenceItemsChunker.PhoneCallChunk = PhoneCallChunk;
SequenceItemsChunker.VideoChatChunk = VideoChatChunk;
SequenceItemsChunker.SystemMessageChunk = SystemMessageChunk;

export default SequenceItemsChunker;
